module.exports = __webpack_public_path__ + "static/media/ug.8bcdae8b.svg";